module.exports = __webpack_public_path__ + "static/media/19-4.4a5e927c.mp3";